export default "__VITE_ASSET__8b5887df__"